// extracted by mini-css-extract-plugin
export default {"snackbar":"style_snackbar__dABFX","countdown":"style_countdown__RCeCZ","message":"style_message__rJijo","status":"style_status__fxcQ0","xIcon":"style_xIcon__kHmXC"};